/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import Model from '@tripian/model';
import { api } from '@tripian/core';

import ICombinedState from '../../redux/model/ICombinedState';
import { loginFinally } from '../../redux/action/user';

import { LOGIN_WITH_HASH, TRIP_PLAN, OVERVIEW } from '../../constants/ROUTER_PATH_TITLE';
import config from '../../config';
import InitLoading from '../../components/InitLoading/InitLoading';
import { saveError } from '../../redux/action/trip';

const LoginWithHashPage = () => {
  const isLoggedIn = useSelector((state: ICombinedState) => state.user.isLoggedIn);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  document.title = LOGIN_WITH_HASH.TITLE;

  useEffect(() => {
    const from: any = location.state || { from: { pathname: '/' } };

    const redirectToFrom = () => {
      history.replace(from.from);
    };

    const loginHashPromise = (tripHash: string): void => {
      api
        .loginTripHash(tripHash)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .then((token: Model.Token) => {
          dispatch(loginFinally());
        })
        .catch((loginError) => {
          dispatch(saveError('login', 'Hash Login', loginError));
        });
    };

    if (isLoggedIn) {
      redirectToFrom();
    } else if (config.LOGIN_WITH_HASH) {
      let fromPage = '';
      if (from.from.startsWith(`${TRIP_PLAN.PATH}/`)) {
        fromPage = `${TRIP_PLAN.PATH}/`;
      } else if (from.from.startsWith(`${OVERVIEW.PATH}/`)) {
        fromPage = `${OVERVIEW.PATH}/`;
      }
      if (fromPage !== '') {
        const tripHash = from.from.replace(fromPage, '');
        loginHashPromise(tripHash);
      } else {
        // eslint-disable-next-line no-console
        console.warn('wrong redirect from page');
      }
    }
  }, [isLoggedIn, history, location, dispatch]);

  return (
    <>
      <InitLoading message="Wellcome to butter" />
    </>
  );
};

export default LoginWithHashPage;
